import { SvgIconComponent } from '../types/svgs';

const ActivityAction: SvgIconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7L6.25 9.25L10 4.75M13 3.39996V10.6C13 11.44 13.0002 11.8602 12.8367 12.181C12.6929 12.4633 12.4631 12.6927 12.1808 12.8365C11.86 13 11.4402 13 10.6001 13H3.40015C2.56007 13 2.13972 13 1.81885 12.8365C1.5366 12.6927 1.3073 12.4633 1.16349 12.181C1 11.8602 1 11.44 1 10.6V3.39996C1 2.55988 1 2.1399 1.16349 1.81903C1.3073 1.53679 1.5366 1.3073 1.81885 1.16349C2.13972 1 2.56007 1 3.40015 1H10.6001C11.4402 1 11.86 1 12.1808 1.16349C12.4631 1.3073 12.6929 1.53679 12.8367 1.81903C13.0002 2.1399 13 2.55988 13 3.39996Z"
        stroke="#394642"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActivityAction;
